import axiosInstance from "./axiosInstance";
import APIEndpoint from "./endpoint";

export const getQuarter = async () => {
  const url = `${APIEndpoint.GET_QUARTER}`;

  const res = await axiosInstance.get(url);
  return res;
};

export const getInstitution = async () => {
  const url = `${APIEndpoint.GET_INSTITUTION}`;

  const res = await axiosInstance.get(url);
  return res;
};

export const getChanel = (id) => {
  const uid = id;
  const api = APIEndpoint.GET_CHANEL + `?institutionId=`;
  const res = axiosInstance.get(api + uid);
  return res;
};

export const getQuestion = (id, channel) => {
  const uid = id;
  const channelData = channel;
  const api =
    APIEndpoint.GET_QUESTION +
    `?institutionId=` +
    uid +
    `&channel=` +
    channelData;
  const res = axiosInstance.get(api);
  return res;
};

export const getPosition = async () => {
  const url = `${APIEndpoint.GET_POSITION}`;

  const res = await axiosInstance.get(url);
  return res;
};

export const getStaffName = async () => {
  const url = `${APIEndpoint.GET_STAFFNAME}`;

  const res = await axiosInstance.get(url);
  return res;
};

export const createTouchPointPage = async (request, id) => {
  const url = `${APIEndpoint.POST_TOUCHPOINT}`;

  const res = await axiosInstance.post(url, JSON.stringify(request));
  return res;
};

export const getDetailTouchPointPage = async (id) => {
  console.log("getDetailTouchPointPage<====");
  const url = `${APIEndpoint.GET_DETAILTOUCHPOINT}`;

  const res = await axiosInstance.get(url + "/" + id);
  return res;
};

export const deleteTouchPoint = (id) => {
  const uid = id;
  const api = APIEndpoint.DELETE_TOUCHPOINT + "/";
  const res = axiosInstance.delete(api + uid);
  return res;
};

export const getChannelHeader = async () => {
  const url = `${APIEndpoint.GET_CHANNEL_HEADER}`;

  const res = await axiosInstance.get(url);
  return res;
};

export const searchTouchPoint = (searchValues, pageValues) => {
  const api = APIEndpoint.SEARCH_TOUCHPOINT;

  let payload = {
    requestObject: {
      institutionId: searchValues.institutionId
        ? searchValues.institutionId
        : null,
      channel: searchValues.channel ? searchValues.channel : null,
      quarterOfBudget: searchValues.quarterOfBudget
        ? searchValues.quarterOfBudget
        : null,
      yearOfBudget: searchValues.yearOfBudget
        ? searchValues.yearOfBudget
        : null,
      groupsByNationality: searchValues.groupsByNationality
        ? searchValues.groupsByNationality
        : [],
      groupsByAge: searchValues.groupsByAge ? searchValues.groupsByAge : null,
      estateName: searchValues.estateName ? searchValues.estateName : null,
    },
    pageValue: {
      page: pageValues.page,
      pageSize: pageValues.pageSize,
      sortBy: pageValues.sortBy,
      sortDirection: pageValues.sortDirection,
    },
  };

  const res = axiosInstance.post(api, JSON.stringify(payload));
  return res;
};

export const getAge = async () => {
  const url = `${APIEndpoint.GET_AGE}`;

  const res = await axiosInstance.get(url);
  return res;
};

export const getNation = async () => {
  const url = `${APIEndpoint.GET_NATION}`;

  const res = await axiosInstance.get(url);
  return res;
};

export const editTouchPointPage = async (request) => {
  const url = `${APIEndpoint.POST_TOUCHPOINT}`;

  const res = await axiosInstance.put(url, JSON.stringify(request));
  return res;
};
